import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[awCardHeader]',
    standalone: true,
})
export class CardHeaderDirective {
    constructor(public template: TemplateRef<any>) {}
}
